import { Button, Input, List, Select, Skeleton, message } from "antd";
import { useEffect, useState } from "react";
import axiosInstance from "../../axios";

import { CreRightSidePanelCommentType, CreRightSidePanelType } from "./types";
import TheSpinner from "../TheSpinner";

import { popupTitleAndMessage } from "../utils/notificationPopup";
import { TABLE_LIMIT } from "../constants";
import { dateTimeDisplayable } from "../table-utils";

export function CreRightSidePanel(props: CreRightSidePanelType) {
  const { dealings_id, studentDealStatus, studentDealPriorityStatus } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [commentLoading, setCommentLoading] = useState<boolean>(true);
  const [page, setPage] = useState(1);
  const [allAssignableCre, setallAssignableCre] = useState<any[]>(); // update type
  const [assignedCreId, setAssgnedCreId] = useState<number>();
  const [assignedCreName, setAssgnedCreName] = useState<number>();
  const [skeletonList, setSkeletonList] = useState<
    CreRightSidePanelCommentType[]
  >([]);
  const [commentList, setCommentList] = useState<
    CreRightSidePanelCommentType[]
  >([]);
  const [commentMeta, setCommentMeta] = useState<any>({});
  const [comment, setComment] = useState("");
  const [canEdit, setCanEdit] = useState<boolean>(false);

  useEffect(() => {
    getAllAssignableCre();
    setPage(1);
    getAllDealComments([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealings_id]);
  
  useEffect(() => {
    setPage(1);
    getAllDealComments([]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentDealStatus, studentDealPriorityStatus]);

  useEffect(() => {
    if (page > 1) {
      getAllDealComments(commentList);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  async function getAllAssignableCre() {
    try {
      const { data } = await axiosInstance.get(
        `/v1/cre/student/deal/get-assigned-cre/${dealings_id}`
      );
      console.log("get assignable cre", data);
      if (data.success) {
        setallAssignableCre(data?.data?.creAdmins);
        setAssgnedCreId(data?.data?.defaultAdmin?.admin_id);
        setAssgnedCreName(data?.data?.defaultAdmin?.admin_name);
        setCanEdit(data?.data?.canEdit);
      }
    } catch (error) {}
    setLoading(false);
  }

  async function updateAssignedCre(admin_id: number) {
    try {
      if (!dealings_id) {
        throw new Error("somethin went wring");
      }
      const { data } = await axiosInstance.post(
        `/v1/cre/student/deal/update-assigned-cre`,
        {
          admin_id,
          dealings_id,
        }
      );
      if (data.success) {
        setAssgnedCreId(data?.data?.admin_id);
        setAssgnedCreName(data?.data?.admin_name);
        setPage(1);
        getAllDealComments([]);
        message.success(
          popupTitleAndMessage["UPDATE_DEAL_ASSIGNED_CRE"]["success"]
            .description
        );
      } else {
        message.error(
          data.message ??
            popupTitleAndMessage["UPDATE_DEAL_ASSIGNED_CRE"]["error"]
              .description
        );
      }
    } catch (error: any) {
      message.error(
        error.message ??
          popupTitleAndMessage["UPDATE_DEAL_ASSIGNED_CRE"]["error"].description
      );
    }
    setLoading(false);
  }

  async function getAllDealComments(commentListV2: any[]) {
    try {
      setSkeletonList([
        ...commentListV2,
        ...Array.from({ length: TABLE_LIMIT }).map(() => ({ loading: true })),
      ]);
      const { data } = await axiosInstance.get(
        `/v1/cre/student/deal/deal-comment/${dealings_id}`,
        {
          params: {
            page,
            limit: TABLE_LIMIT,
          },
        }
      );

      if (data.success) {
        setCommentList([...commentListV2, ...data?.data?.comments]);
        setSkeletonList([...commentListV2, ...data?.data?.comments]);
        setCommentMeta(data?.data?.meta);
      }
    } catch (error) {}
    setLoading(false);
    setCommentLoading(false);
  }

  async function addDealComment() {
    try {
      if (!dealings_id || !comment) {
        message.error("Please provide comment.");
      }
      const { data } = await axiosInstance.post(
        `/v1/cre/student/deal/deal-comment`,
        {
          comment,
          dealings_id,
        }
      );
      setLoading(false);
      if (data.success) {
        setPage(1);
        getAllDealComments([]);
        message.success(
          popupTitleAndMessage["ADD_DEAL_COMMENT"]["success"].description
        );
        setComment("");
      } else {
        message.error(
          data.message ??
            popupTitleAndMessage["ADD_DEAL_COMMENT"]["error"].description
        );
      }
    } catch (error: any) {
      message.error(
        error.message ||
          popupTitleAndMessage["ADD_DEAL_COMMENT"]["error"].description
      );
    }
  }

  if (loading) {
    return <TheSpinner />;
  }

  const loadMore = (
    <div>
      {!commentLoading ? (
        <div className="tail-flex tail-justify-center tail-items-center tail-mt-4 ">
          <Button
            onClick={() => {
              setCommentLoading(true);
              setPage(page + 1);
            }}
            disabled={page >= commentMeta?.last_page}
          >
            loading more
          </Button>
        </div>
      ) : null}
    </div>
  );

  return (
    <>
      <div className="tail-w-full tail-flex tail-flex-col tail-h-screen">
        {/* Sticky Top Select */}
        <div className="tail-sticky tail-top-0 tail-z-10 tail-pb-2">
          <Select
            size="large"
            // disabled={!canEdit}
            value={allAssignableCre?.length ? assignedCreId : assignedCreName}
            options={allAssignableCre?.map((cre) => ({
              value: cre.admin_id,
              label: cre.admin_name,
            }))}
            onChange={(value) => {
              setLoading(true);
              updateAssignedCre(value);
            }}
            className="tail-rounded-md tail-w-full"
          ></Select>
        </div>

        <div
          className="tail-flex-1 tail-overflow-y-auto tail-border tail-p-2 tail-rounded-md"
          style={{
            height: 0,
            minHeight: 0,
          }}
        >
          <List
            className="comment-loadmore-list"
            loading={loading}
            itemLayout="horizontal"
            loadMore={loadMore}
            dataSource={skeletonList}
            renderItem={(item) => (
              <List.Item key={item.id}>
                <Skeleton avatar title={false} loading={item.loading} active>
                  <List.Item.Meta
                    // description={item?.comment}
                    title={`${item?.admin_name} (${item?.admin_id})`}
                  />
                </Skeleton>
                {item?.comment}
                <p className="tail-text-xs tail-text-gray-500 tail-py-1">
                  {dateTimeDisplayable(item.created_at as string)}
                </p>
              </List.Item>
            )}
          />
        </div>

        <div className="tail-sticky tail-bottom-0 tail-z-10 tail-bg-white tail-border-t tail-pt-2 tail-mb-2">
          <Input.TextArea
            rows={6}
            placeholder="Max Character allowed is 255"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <Button
            type="primary"
            className="tail-mt-2"
            onClick={() => {
              setLoading(true);
              addDealComment();
            }}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
}

/* <List
          itemLayout="vertical"
          size="small"
          pagination={{
            total: commentMeta?.total ?? 0,
            pageSize: TABLE_LIMIT,
            onChange: (page, _pageSize) => setPage(page),
            showSizeChanger: false,
            current: page,
          }}
          dataSource={commentList}
          renderItem={(item) => (
            <List.Item key={item.id}>
              <List.Item.Meta
                description={item?.comment}
                title={item?.admin_name}
              />
              <p className="tail-text-xs tail-text-gray-500">
                {dateDisplayable(item.created_at)}
              </p>
            </List.Item>
          )}
        /> */

/* <div className="tail-w-full tail-flex tail-flex-col tail-justify-between tail-grow tail-border  tail-p-2 tail-rounded-md">
        <List
          className="demo-loadmore-list"
          loading={loading}
          itemLayout="horizontal"
          loadMore={loadMore}
          // dataSource={commentList}
          dataSource={skeletonList}
          renderItem={(item) => (
            <List.Item key={item.id}>
              <Skeleton avatar title={false} loading={item.loading} active>
                <List.Item.Meta
                  description={item?.comment}
                  title={item?.admin_name}
                />
              </Skeleton>
            </List.Item>
          )}
        />

        <div className="tail-flex tail-flex-col tail-gap-y-2">
          <Input.TextArea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          ></Input.TextArea>
          <Button
            type="primary"
            onClick={() => {
              setLoading(true);
              addDealComment();
            }}
          >
            Submit
          </Button>
        </div>
      </div> */

/* 
      <div className="tail-w-full tail-flex tail-flex-col tail-h-screen tail-gap-4">
        <div className="tail-sticky tail-top-0 tail-z-10 tail-bg-white tail-pb-2">
          <Select
            size="large"
            // disabled={!canEdit}
            value={assignedCre}
            options={allAssignableCre?.map((cre) => ({
              value: cre.admin_id,
              label: cre.admin_name,
            }))}
            onChange={(value) => {
              setLoading(true);
              console.log(value);
              updateAssignedCre(value);
            }}
            className="tail-rounded-md"
          ></Select>
        </div>
          <div className="tail-flex-1 tail-overflow-y-auto tail-border tail-p-2 tail-rounded-md">
            <List
              className="demo-loadmore-list"
              loading={loading}
              itemLayout="horizontal"
              loadMore={loadMore}
              dataSource={skeletonList}
              renderItem={(item) => (
                <List.Item key={item.id}>
                  <Skeleton avatar title={false} loading={item.loading} active>
                    <List.Item.Meta
                      description={item?.comment}
                      title={item?.admin_name}
                    />
                  </Skeleton>
                </List.Item>
              )}
            />
          </div>

          <div className="tail-sticky tail-bottom-0 tail-z-10 tail-bg-white tail-border-t tail-pt-2 tail-pb-2">
            <Input.TextArea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            ></Input.TextArea>
            <Button
              type="primary"
              onClick={() => {
                setLoading(true);
                addDealComment();
              }}
            >
              Submit
            </Button>
          </div>
      </div> */
